import React, {useState, useEffect, useMemo, useContext} from "react";
import { useForm } from "react-hook-form";
import {Link, useLocation, useParams} from "react-router-dom";
import moment from 'moment';
import {Backdrop, Grid} from "@material-ui/core";
import {MUIDataTableColumnDef, MUISortOptions} from "mui-datatables";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import GenericTemplate from "../../../templates/GenericTemplate";
import {
  StrOption,
  apollo_useStyles, Option, options_gender, options_ostype_zeus_number, options_pref,
  options_state_edit,
  options_zeus_billing_type,
  valueToOption,
  valueToOptionNull,
  ZEUS_DELIVERY_TYPE_STRING,
  ZEUS_DELIVERY_TYPE_STRING_SHORT,
  options_zeus_pmp_type,
  options_display_parent_archive_adgroups,
} from "../../../atom/Apollo_styles_Beta";
import {
  options_select_all,
} from "../../../atom/Apollo_Options";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloUserProfileAuth, APOLLO_PROFILE_SYSTEM_ADMIN, IsAuthorization} from "../../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {
  adgroupedit_path,
  advertisements_path,
  get_zeus_ad_group_performance_path,
  get_zeus_campaign_path,
  get_zeus_ad_group_path,
  patch_zeus_ad_group_path,
  apollo_setpoints_path,
  get_zeus_placement_settings,
} from "../../../atom/Apollo_links";
import {ApolloRightDrawerContext, RightDrawer} from "../../../molecule/Apollo_RightDrawer";
import {ApolloDateRangePicker} from "../../../atom/Apollo_DateRangePicker";
import ApolloPerformance from "../../../molecule/Apollo_Performance";
import {ROW_PER_PAGE_OPTIONS} from "../../../common/Apollo_CommonConst";
import {
  APOLLO_PAGE_ID,
  applyApolloSharedColumnSettings,
  createApolloSharedTableOptions,
  getApolloSharedCalendar,
  saveApolloSharedCalendar,
} from "../../../common/Apollo_LocalStorageSettings";
import {
  ApolloBasicSelect,
} from "../../../molecule/Apollo_BaseItem";
import {
  createApolloCsvBlob,
  formatApolloCsvCell,
  formatApolloCsvCellArray,
  toUtcIso8601str,
  valueToLabel,
  mergeOptions,
} from "../../../common/Apollo_CommonUtil_Beta";
import {LintChartColumnsPtn, LintChartStorageKey} from "../../SUMMARY/LineChart_Beta";
import {
  generateCsvHeader,
  generateSetPointColumns,
  generateColumns,
} from "../../SUMMARY/IndividualSummary";
import {DataTableOptions, STORAGE_KEY} from "../../../atom/Apollo_DataTable";
import {Bars} from "react-loader-spinner";
import {
  AdGroupsZeusColumns,
  CsvData,
  UNDER_SCORE,
  ALL,
  MSG,
  RESULT_SETPOINT_ERROR,
  TRACKING_POINT,
} from "../../../common/Apollo_CommonConst_Beta";
import AdGroupEditZeus from "./AdGroupEditZeus";
import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../../atom/Apollo_ApiRequest3";
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import {
  AdGroupWithPerformanceZeus,
  ChartRawDataZeus,
  Demographic,
  DemographicRelation,
  OsTargeting,
  PlacementSettging
} from "./AdGroupModelZeus";
import {Theme, withStyles, makeStyles} from "@material-ui/core/styles";
import Switch from '@material-ui/core/Switch';
import {ApolloContext} from "../../../atom/Apollo_Context";
import {ApolloEventRecord, LogData, ItemList} from "../../../atom/Apollo_EventRecord";
import {AdGroupZeus, AudienceRelations, AdGroupEditReq} from "./AdGroupModelZeus";
import {cloneDeep} from "lodash";
import {
  options_zeus_ad_target,
  options_zeus_ad_target_for_display,
  TARGET_TYPE
} from "./common/CommonConst";
import { CampaignZeus } from "./../../CAMPAIGN/zeus/CampaignModelZeus"

const ApolloPerformanceMemo = React.memo(ApolloPerformance);

const TopTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    maxWidth: 380,
    backgroundColor: 'rgba(243,245,255,0.87)',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 16,
  },
}))(Tooltip);

const apollo_AdGroupStyles = makeStyles({
  targetingDisplayCircleZeus: {
    color: "white",
    textAlign: "center",
    backgroundColor: "#2196f3",
    width: "25px",
    height: "24px",

    borderRadius: "60%",
    verticalAlign: "middle",

  },
  hiddenButtonMs: {
    opacity: 0,
    "&:hover": {
      opacity: 1
    },
  },
});

const DATE_TIME_SUFFIX = "Z"
const BLANK = ""
const DISPLAYSTATUS_BLACKLIST = 2
const DISPLAYSTATUS_WHITELIST = 3
const PUBLICSTATUS_PRIVATE = 2

// 画面名：広告グループ一覧（Zeus）
const AdGroupPageZeus: React.FC = () => {
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {accountgroupid, accountid, platformaccountid} = useParams<{
    accountgroupid: string,
    accountid: string,
    platformaccountid: string,
  }>();
  const {state} = React.useContext(ApolloContext);
  const displayParentArchiveFilterValue: number[] = state.filterInfo.displayParentArchiveFilterValue;
  const reqParams = new URLSearchParams(useLocation().search);
  const campaignId = reqParams.get("campaignId") ?? "0";
  const [tableData, setTableData] = useState<AdGroupWithPerformanceZeus[]>([])
  const [chartRawData, setChartRawData] = useState<ChartRawDataZeus[]>([])
  const [reflectAt, setReflectAt] = useState<string>("")
  const [adGroupId, setAdGroupId] = useState<number>(0);
  const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN);
    
  const MIN_START_DATE = moment("2025-10-01");
  const DEFAULT_END_DATE = moment("2025-10-31");
  const LIMIT_DATE = moment("2025-09-30");

  // 条件判定
  const isBeforeLimit = moment().isSameOrBefore(LIMIT_DATE, "day");

  const defaultStartDate = !isAuthorization && isBeforeLimit
    ? toUtcIso8601str(MIN_START_DATE)
    : toUtcIso8601str(moment().startOf("month"));
  const defaultEndDate = !isAuthorization && isBeforeLimit
    ? toUtcIso8601str(DEFAULT_END_DATE)
    : toUtcIso8601str(moment().endOf("month"));
  const initialCalendar = getApolloSharedCalendar({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  const [startDate, setStartDate] = useState(initialCalendar.startDate);
  const [endDate, setEndDate] = useState(initialCalendar.endDate);
  const [previousStartDate, setPreviousStartDate] = useState(toUtcIso8601str(moment().startOf('month')))
  const [previousEndDate, setPreviousEndDate] = useState(toUtcIso8601str(moment().endOf('month')))
  const [previousChartRawData, setPreviousChartRawData] = useState<ChartRawDataZeus[]>([])
  const [isPreviousPeriodChecked, setIsPreviousPeriodChecked]= useState<boolean>(false)
  const [isPreviousPeriodDisabled, setIsPreviousPeriodDisabled]= useState<boolean>(false)
  const [isChartDataLoaded, setIsChartDataLoaded] = useState(false);
  const [selectedValues, setSelectedValues] = useState<string[]>([ALL]);
  const [setPoints, setSetPoints] = useState<Option[]>([]);
  const [deletedSetPoints, setDeletedSetPoints] = useState<Option[]>([]);
  const [isSetPointsLoaded, setIsSetPointsLoaded] = useState(false);

  const classes = apollo_useStyles();
  const adGroupclasses = apollo_AdGroupStyles();
  const [updateListCnt, setUpdateListCnt] = useState<number>(0);
  const [optionCampaigns, setOptionCampaigns] = useState<Option[]>([]);
  const [placementSettings, setPlacementSettings] = useState<PlacementSettging[]>([]);
  const [placementSettingsOptions, setPlacementSettingsOptions] = useState<Option[]>([]);
  const [campaigns, setCampaigns] = useState<CampaignZeus[]>([]);
  // ステータストグル押下フラグ
  const [isPushStatusToggle, setIsPushStatusToggle] = useState<boolean>(false);

  // 期間変更比較
  type BeforeStartEndDate = {
    startDate: string,
    endDate: string,
  }
  const currentBeforeDate = React.useRef<BeforeStartEndDate>({
    startDate: "",
    endDate: "",
  });
  const previousBeforeDate = React.useRef<BeforeStartEndDate>({
    startDate: "",
    endDate: "",
  });
  // useForm
  const {
    control,
    errors,
  } = useForm({reValidateMode: 'onBlur'});

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 24,
    breadId: 1,
    queries: [],
    menu: {
      id: 1,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const initEditAdGroup: AdGroupWithPerformanceZeus = {
    id: 0,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: "",
    adAccountId: 0,
    adCampaignId: 0,
    name: "",
    campaignType: "",
    status: 0,
    displayParentArchiveCode: 0,
    billingType: 0,
    cpcLimit: 0,
    cpmLimit: 0,
    osTargetings: [],
    osTargetingsLabel: "",
    targetingType: 0,
    demographicRelations: [],
    audienceRelations: [],
    segmentRelations: [],
    cost: 0,
    imp: 0,
    click: 0,
    ctr: 0,
    cpc: 0,
    cpm: 0,
    trackingPointCvTotal: 0,
    trackingPointCvClickThrough: 0,
    trackingPointCvAssist: 0,
    trackingPointCpaTotal: 0,
    trackingPointCpaClickThrough: 0,
    trackingPointCpaAssist: 0,
    trackingPointCvrTotal: 0,
    trackingPointCvrClickThrough: 0,
    trackingPointCvrAssist: 0,
    lastCvTotal: 0,
    lastCpaTotal: 0,
    lastCvrTotal: 0,
    trackingPointCvClickThroughSetPoints: [],
    trackingPointCvAssistSetPoints: [],
    trackingPointCpaClickThroughSetPoints: [],
    trackingPointCvrClickThroughSetPoints: [],
    placementSettingId: 0,
    pmpType: "",
  }

  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "id",
    direction: 'desc',
  })

  // 表で使用するパラメータをMemo化
  const chartRawDataMemo =  useMemo(() => chartRawData.map(value => value.performances), [selectedValues, chartRawData, previousChartRawData, campaigns]);
  const previousChartRawDataMemo =  useMemo(() => previousChartRawData.map(value => value.performances), [selectedValues, chartRawData, previousChartRawData, campaigns]);
  const setpointMemo =  useMemo(() => mergeOptions(setPoints, deletedSetPoints), [setPoints, deletedSetPoints]);
  const titleMemo = useMemo(() =>
    <React.Fragment>
      <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
        <Tooltip title="広告グループ新規作成" placement="bottom">
          <Link
            to={`${adgroupedit_path}zeus/${accountgroupid}/${accountid}/${platformaccountid}?campaignId=${campaignId}`}>
            <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
              <AddIcon/>
            </Fab>
          </Link>
        </Tooltip>
      </ApolloUserProfileAuth>
      <p style={{fontSize: "15px"}}>
        {
          "実績値取得日時: " +
          (
            reflectAt
              ? moment(reflectAt.replace(DATE_TIME_SUFFIX, BLANK)).format("YYYY-MM-DD HH:mm:ss")
              : BLANK
          )
        }
      </p>
    </React.Fragment>, [reflectAt])
  const createTableOptions = (columnsForStorage: MUIDataTableColumnDef[]): DataTableOptions => createApolloSharedTableOptions({
    print: false,
    downloadOptions: {
      filename: ``,
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const fileName = `adGroups_performance_${moment(startDate).format("YYYYMMDD")}_${moment(endDate).format("YYYYMMDD")}.csv`;
      const csvData = formatCsvData(data, tableData, optionCampaigns, setPoints, deletedSetPoints, placementSettingsOptions);
      const blob = createApolloCsvBlob(generateCsvHeader(AdGroupsZeusColumns, setPoints, deletedSetPoints), csvData);
      const link = document.createElement("a");
      link.setAttribute("href", window.URL.createObjectURL(blob));
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      return false;
    },
    elevation: 0,
    sortOrder: localStorage.getItem(STORAGE_KEY.ZEUS_AD_GROUP_LIST) ? undefined : sortOrder,
    selectToolbarPlacement: "above",
    filterType: "multiselect",
    customToolbarSelect: () => undefined,
    storageKey: STORAGE_KEY.ZEUS_AD_GROUP_LIST,
    jumpToPage: true,
    rowsPerPageOptions: ROW_PER_PAGE_OPTIONS.HOME_AND_MAIN_LEVELS,
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions)
    },
  }, {
    pageId: APOLLO_PAGE_ID.ADGROUP_ZEUS,
    accountGroupId: accountgroupid,
    columns: columnsForStorage,
  });
  const [columnFilterForStatus] = useState(options_state_edit.filter(elem => elem.value !== 3).map(elem => elem.label))
  const [columnFilterForDisplayParentArchive] = useState(
    options_display_parent_archive_adgroups.filter(elem => (displayParentArchiveFilterValue??[]).includes(elem.value)).map(elem => elem.label)
  )

  const listReloadFunc = () => {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    })
    setUpdateListCnt(updateListCnt + 1)
  };

  useEffect(() => {
    if (!isSetPointsLoaded && !isPushStatusToggle) return;

    setIsChartDataLoaded(false);
    const start = moment(startDate);
    const end = moment(endDate);
    const diffDays = end.diff(start, 'days') + 1;
    const previousStart = start.subtract(diffDays, 'days').format('YYYY-MM-DD');
    const previousEnd = end.subtract(diffDays, 'days').format('YYYY-MM-DD');
    setPreviousStartDate(previousStart);
    setPreviousEndDate(previousEnd);

    const fetchCampaigns = async () => {
      if (startDate === currentBeforeDate.current.startDate && endDate === currentBeforeDate.current.endDate && !isPushStatusToggle && !adGroupId) return;
      ApolloAxios.get(`${get_zeus_campaign_path}?account_id=${platformaccountid}&per_page=9999&page=1&sort=created&direction=desc`).then((response) => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "キャンペーンの取得に失敗しました",
          });
        }
        const newCampaigns: Option[] = [];
        response.data?.map(function (data: { id: number, name: string }) {
          const option: Option = {
            value: data.id,
            label: data.name,
          }
          newCampaigns.push(option);
        });
        setOptionCampaigns(newCampaigns);
        setCampaigns(response.data ?? [])
      })
        .catch(() => {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: "データ取得に失敗しました"
            }
          });
        });
    }

    const fetchAdGroups = async () => {
      if (startDate === currentBeforeDate.current.startDate && endDate === currentBeforeDate.current.endDate && !isPushStatusToggle && !adGroupId) return;
      setProgress(true);
      let url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ad_group_performance_path}?account_id=${platformaccountid}&startDateTime=${startDate}&endDateTime=${endDate}&per_page=9999&page=1&sort=created&direction=desc`
      if (campaignId !== "0") url += `&campaign_id=${campaignId}`;
      await ApolloAxios.get(url, {}).then((response) => {
        const res: ApiResponse = response.data;
        if (!isSuccessApi(res.resultCode)) {
          return Promise.reject({
            open: true,
            type: getResultType(res.resultCode),
            errmsg: res?.message ? res.message : "広告グループ情報の取得に失敗しました",
          });
        }
        const localTableData: AdGroupWithPerformanceZeus[] = res.result?.list ?? []
        setTableData(localTableData.map(elem => {
          const osTargetings: OsTargeting[] = elem.osTargetings?.sort((a, b) => a.osType - b.osType);

          const osTargetingsLabelList: string[] = [];
          osTargetings.forEach((data: OsTargeting)=>{
            const option = valueToOptionNull(data.osType, options_ostype_zeus_number);
            if(option) {
              osTargetingsLabelList.push(option.label)
            }
          })
          const osTargetingsLabel: string = osTargetingsLabelList.join("/")

          const retElem: AdGroupWithPerformanceZeus = {
            ...elem,
            osTargetings: osTargetings,
            osTargetingsLabel: osTargetingsLabel,
          };
          return retElem;
        }));
        if (res.result?.chartData) setChartRawData(res.result.chartData);
        if (res.result?.reflectAt) setReflectAt(res.result.reflectAt);
        currentBeforeDate.current = {startDate: startDate, endDate: endDate,}
      })
        .catch(() => {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: "データ取得に失敗しました"
            }
          });
        }).finally(() => {
          setProgress(false);
      });
    }

    const fetchPreviousAdGroups = async () => {
      if (!isPreviousPeriodChecked && !isPushStatusToggle) return;
      if (startDate === previousBeforeDate.current.startDate && endDate === previousBeforeDate.current.endDate && !isPushStatusToggle && !adGroupId) return;
      setIsPreviousPeriodDisabled(true);
      let url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ad_group_performance_path}?account_id=${platformaccountid}&startDateTime=${previousStart}&endDateTime=${previousEnd}&per_page=9999&page=1&sort=created&direction=desc`
      if (campaignId !== "0") url += `&campaign_id=${campaignId}`;
      await ApolloAxios.get(url, {}).then((response) => {
        const res: ApiResponse = response.data;
        if (!isSuccessApi(res.resultCode)) {
          return Promise.reject({
            open: true,
            type: getResultType(res.resultCode),
            errmsg: res?.message ? res.message : "広告グループ情報の取得に失敗しました",
          });
        }
        if (res.result.chartData) setPreviousChartRawData(res.result.chartData);
        previousBeforeDate.current = {startDate: startDate, endDate: endDate,}
      })
        .catch(() => {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: "データ取得に失敗しました"
            }
          });
        }).finally(() => {
          setIsPreviousPeriodDisabled(false);
        });
    }

    const fetchOptions = async () => {
      fetchCampaigns();
    }

    const fetchPlacementSettings = async () => {
      ApolloAxios.get(`${get_zeus_placement_settings}`).then((response) => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "プレースメント設定の取得に失敗しました",
          });
        }

        setPlacementSettings(response.data?.result ?? [])
      })
        .catch(() => {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: "データ取得に失敗しました"
            }
          });
        });
    }

    const fetchAll = async () => {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: true
        }
      });
      await Promise.all(
        [fetchOptions(), fetchAdGroups(), fetchPreviousAdGroups(), fetchPlacementSettings()]
      ).catch(() => {
        setProgress(false);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        });
      }).finally(() => {
        setProgress(false);
        setIsPushStatusToggle(false);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setIsChartDataLoaded(true);
      });
    }
    fetchAll();

  }, [startDate, endDate, updateListCnt, isSetPointsLoaded, isPreviousPeriodChecked]);

  useEffect(() => {
    const fetchSetPoints = () => {
      const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_setpoints_path}/${accountid}`;
      ApolloAxios.get(url).then((response) => {
        if (response.data?.resultCode === RESULT_SETPOINT_ERROR) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: `${MSG.ERROR_GET_SET_POINTS}${response?.data?.message ?? BLANK}`
            }
          });
        } else if (response.data.result) {
          const newSetPoints: Option[] = [];
          const newDeletedSetPoints: Option[] = [];
          response.data?.result?.map(function (data: { setPointId: number, setPointName: string, setPointDeleteFlg: number }) {
            if (data.setPointDeleteFlg === 0) {
              const option: Option = {
                value: data.setPointId,
                label: `${data.setPointId}${UNDER_SCORE}${data.setPointName}`,
              }
              newSetPoints.push(option);
            } else {
              const option: Option = {
                value: data.setPointId,
                label: `${data.setPointId}${UNDER_SCORE}${data.setPointName}（削除済み）`,
              }
              newDeletedSetPoints.push(option);
            }
          });
          setSetPoints(newSetPoints);
          setDeletedSetPoints(newDeletedSetPoints);
        }
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `${MSG.ERROR_GET_SET_POINTS}${err?.errmsg ?? BLANK}`
          }
        });
      }).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setIsSetPointsLoaded(true);
      });
    }

    const fetchAll = async () => {
      await Promise.all(
        [fetchSetPoints()]
      ).finally(() => {
      })
    }

    fetchAll();

  }, []);

  useEffect(() => {
    // NOTE: 取引形式の表示を制御。
    //       ここで制御している理由としては、広告G一覧の情報だけだと pmpType がNULLの場合に原因が
    //      ・キャンペーン種別がPerformance
    //      ・キャンペーン種別がコネパスDSP且つ、取引形式がオープンオークション
    //      のどちらかの判断が出来ない為、キャンペーン一覧の情報と合わせ、表示させたい為。
    tableData.forEach((adGroup: AdGroupWithPerformanceZeus) => {
      campaigns.forEach((campaign: CampaignZeus)=>{
        if(adGroup.adCampaignId === campaign.id) {
          if(adGroup.campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.PERFORMANCE) {
            adGroup.pmpType = "-"
          } else if (adGroup.campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.DSP) {
            const option = valueToOption(campaign.pmpType, options_zeus_pmp_type);
            adGroup.pmpType = option?.label ?? ""
          }
        }
      })
    })
    setTableData(tableData)
  }, [campaigns, tableData]);

  useEffect(() => {
    // 使用しているプレースメント設定IDのリストを作成
    const placementSettingIds: number[] = [];
    tableData.forEach(function (data: AdGroupWithPerformanceZeus) {
      if(!placementSettingIds.includes(data.placementSettingId)) {
        placementSettingIds.push(data.placementSettingId);
      }
    })

    // 上記作成したリストに含まれているプレースメント設定情報のみ、選択肢に追加（必要に応じ「（使用不可）」を追加）
    const newPlacementSettingOptions: Option[] = [{value: 0, label: "-"}];
    placementSettings.filter(x=>placementSettingIds.includes(x.id)).map(function (data: PlacementSettging) {
      let label = data.placementName
      if(data.displayStatus === DISPLAYSTATUS_BLACKLIST && data.adAccountIds.includes(Number(platformaccountid))) {
        label += "（使用不可）"
      } else if (data.displayStatus === DISPLAYSTATUS_WHITELIST && !data.adAccountIds.includes(Number(platformaccountid))) {
        label += "（使用不可）"
      } else if (data.publicStatus === PUBLICSTATUS_PRIVATE) {
        label += "（使用不可）"
      }
      const newPlacementSettging: Option = {
        value: data.id,
        label: label
      }
      newPlacementSettingOptions.push(newPlacementSettging);
    });
    setPlacementSettingsOptions(newPlacementSettingOptions)

  }, [placementSettings, tableData]);

  const createOptions = () => {
    var local_options = [...options_select_all];

    if (tableData && tableData.length > 0) {
      tableData.forEach((data, index) => {
        var opt: StrOption = {
          value: `${index}`,
          label: `${data.id}${UNDER_SCORE}${data.name}`,
        }
        local_options.push(opt);
      });
    }

    return local_options;
  }

  const formatDemographicData = (dg: DemographicRelation):Demographic => {
    const demographic: Demographic = {
      ageRange: [],
      genders: [],
      prefectures: [],
    }
    if (dg.ageMin) demographic.ageRange.push(dg.ageMin);
    if (dg.ageMax) demographic.ageRange.push(dg.ageMax);
    if (dg.genderCodeList) {
      const gCode = dg.genderCodeList.split(",");
      gCode.map((code) => {
        const option = valueToOptionNull(code, options_gender);
        if (option) demographic.genders.push(option.label);
      });
    }
    if (dg.prefCodeList) {
      const pCode = dg.prefCodeList.split(",");
      pCode.map((code) => {
        const option = valueToOptionNull(code, options_pref);
        if (option) demographic.prefectures.push(option.label);
      });
    }

    return demographic;
  }

  const getDemographicDataString = (demographic: Demographic): string => {
    let val: string = "-";
    if(demographic.genders.length > 0) {
      val += "性別：" + demographic.genders.join(" ");
    }
    if(demographic.ageRange.length > 0) {
      val += "年齢：" + demographic.genders.join(" ～ ");
    }
    if(demographic.prefectures.length > 0) {
      val += "居住地指定数：" + demographic.prefectures.length;
    }
    return val;
  }

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <Tooltip title="広告グループ編集" placement="bottom">
              <IconButton
                size="small"
                color="primary"
                aria-label="edit"
                onClick={() => {
                  editIconClick(idx)
                }}>
                <EditIcon/>
              </IconButton>
            </Tooltip>
          );
        }
      },
    },
    {
      name: "id",
      label: "広告グループID",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
      },
    },
    {
      name: "name",
      label: "広告グループ名",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
        customBodyRenderLite: (idx: number) => {
          return (
            <Tooltip title="広告一覧" placement="top">
              <Link
                to={`${advertisements_path}zeus/${accountgroupid}/${accountid}/${platformaccountid}?campaignId=${tableData[idx].adCampaignId}&adGroupId=${tableData[idx].id}`}>
                {tableData[idx].name}
              </Link>
            </Tooltip>
          )
        },
      },
    },
    {
      name: "adCampaignId",
      label: "キャンペーン名",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
        customBodyRender: (value: number) => {
          const option = valueToOptionNull(value, optionCampaigns);
          return option ? option.label : "-";
        }
      },
    },
    {
      name: "campaignType",
      label: "キャンペーン種別",
      options: {
        filter: true,
        sort: true,
        sortCompare: (order: string,) => {
          return (obj1: any, obj2: any) => {
            let val1 = obj1.data;
            let val2 = obj2.data;
            return val1.localeCompare(val2, 'ja') * (order === 'asc' ? 1 : -1);
          };
        },
        setCellProps: () => ({style: {minWidth: "9rem"}}),
        customBodyRender: (value: string) => {
          let background: string = "black"
          switch (true) {
            case value === ZEUS_DELIVERY_TYPE_STRING_SHORT.PERFORMANCE:
              background = "#373c38";
              break;
            case value === ZEUS_DELIVERY_TYPE_STRING_SHORT.DSP:
              background = "#6e75a4";
              break;
            default:
              break;
          }
          return (
            <Chip
              label={
                <Typography variant="subtitle1">
                  {value}
                </Typography>
              }
              style={
                {backgroundColor: background, color: 'white', height: "100%"}
              }
            />
          )
        }
      },
    },
    {
      name: "pmpType",
      label: "取引形式",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: { minWidth: "12rem" }}),
      },
    },
    {
      name: "placementSettingId",
      label: "プレースメント",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: { minWidth: "12rem" }}),
        customBodyRender: (value: number) => {
          const option = valueToOptionNull(value, placementSettingsOptions);
          return option ? option.label : "-";
        }
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        apolloColumnId: "trigger",
        display: !IsAuthorization(APOLLO_GROUP_OPERATOR, APOLLO_SYSTEM_ADMIN)
          ? 'excluded'
          : true,
        setCellProps: () => ({style: {minWidth: "8rem", textAlign: "center"}}),
        customBodyRenderLite: (idx: number) => {
          const status = tableData[idx].status
          if (status === 3) return ("");
          return (
            <Switch
              checked={status === 1 ? true : false}
              onChange={(event, checked) => handleStatusChange(checked, tableData[idx])}
              color="primary"
            ></Switch>
          );
        }
      } as any,
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: true,
        filterList: columnFilterForStatus,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => valueToOption(value, options_state_edit).label,
      },
    },
    {
      name: "displayParentArchive",
      label: "親キャンペーンのステータス",
      options: {
        filter: true,
        filterList: columnFilterForDisplayParentArchive,
        display: false,
        viewColumns: false,
        customBodyRender: (value: number) => valueToOption(value, options_display_parent_archive_adgroups).label,
      },
    },
    {
      name: "billingType",
      label: "課金種別",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => valueToOption(value, options_zeus_billing_type).label,
      },
    },
    {
      name: "cpcLimit",
      label: "目標CPC",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRenderLite: (idx: number) => {
          const row = tableData[idx]
          if (row.campaignType !== "Performance") return "-"
          const v = row.cpcLimit ? "¥" + row.cpcLimit.toLocaleString() : "-";
          return v;
        },
      },
    },
    {
      name: "cpmLimit",
      label: "上限CPM",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRenderLite: (idx: number) => {
          const row = tableData[idx]
          if (row.campaignType !== ZEUS_DELIVERY_TYPE_STRING_SHORT.DSP) return "-"
          const v = row.cpmLimit ? "¥" + row.cpmLimit.toLocaleString() : "-";
          return v;
        },
      },
    },
    {
      // NOTE: フィルターでの表記を制御する為、「osTargetings」ではなく「osTargetingsLabel」を表示
      name: "osTargetingsLabel",
      label: "配信OS",
      options: {
        filter: true,
        sort: true,
        sortCompare: (order: string,) => {
          return (obj1: any, obj2: any) => {
            let val1 = obj1.data;
            let val2 = obj2.data;
            return val1.localeCompare(val2, 'ja') * (order === 'asc' ? 1 : -1);
          };
        },
        setCellProps: () => ({style: {minWidth: "8rem"}}),
      },
    },
    {
      name: "targetingType",
      label: "ターゲティング",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => {
          return (
            <Grid container>
              {/* ノンターゲティングは表示しないので、除いた配列でループを回す */}
              {options_zeus_ad_target_for_display.filter(x => x.value != TARGET_TYPE.NONTARGET).map(elem => {
                return (
                  <Grid item xs={3}>
                    {elem.value === value
                      ? <div className={adGroupclasses.targetingDisplayCircleZeus}>
                        <p className="text">{elem.label}</p>
                      </div>
                      : <></>}
                  </Grid>
                )
              })}
            </Grid>
          )
        },
        filterOptions: {
          renderValue: (value: any) => valueToOptionNull(value, options_zeus_ad_target)?.label ?? ""
        },
        customFilterListRender: (value: number) => {
          return valueToOptionNull(value, options_zeus_ad_target)?.label ?? "";
        }
      },
    },
    {
      name: "demographicRelations",
      label: "デモグラ情報",
      options: {
        filter: false,
        sort: true,
        sortCompare: (order: string,) => {
          return (obj1: any, obj2: any) => {
            let val1: string = "";
            if (!tableData[obj1.position].demographicRelations || tableData[obj1.position].demographicRelations.length === 0) {
              val1 = "-";
            } else {
              const dg1: DemographicRelation = tableData[obj1.position].demographicRelations[0];
              const demographic1: Demographic = formatDemographicData(dg1);
              val1 = getDemographicDataString(demographic1);
            }

            let val2: string = "";
            if (!tableData[obj2.position].demographicRelations || tableData[obj2.position].demographicRelations.length === 0) {
              val2 = "-";
            } else {
              const dg2: DemographicRelation = tableData[obj2.position].demographicRelations[0];
              const demographic2: Demographic = formatDemographicData(dg2);
              val2 = getDemographicDataString(demographic2);
            }
            return val1.localeCompare(val2, 'ja') * (order === 'asc' ? 1 : -1);
          };
        },
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRenderLite: (idx: number) => {
          if (!tableData[idx].demographicRelations || tableData[idx].demographicRelations.length === 0) return "-";

          const dg: DemographicRelation = tableData[idx].demographicRelations[0];
          const demographic: Demographic = formatDemographicData(dg);

          return (
            <React.Fragment>
              {demographic.genders.length > 0 &&
              <Chip label={`性別：${demographic.genders.join(" ")}`} style={{margin: 2}}/>
              }
              {demographic.ageRange.length > 0 &&
              <Chip label={`年齢：${demographic.ageRange.join(" ～ ")}`} style={{margin: 2}}/>
              }
              {demographic.prefectures.length > 0 &&
              <TopTooltip title={demographic.prefectures.join(" ")} placement="top">
                  <Chip label={`居住地指定数：${demographic.prefectures.length}`} style={{margin: 2}}/>
              </TopTooltip>
              }
            </React.Fragment>
          );
        }
      },
    },
    {
      name: "cost",
      label: "cost",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "imp",
      label: "imp",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "click",
      label: "click",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "ctr",
      label: "CTR",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "cpc",
      label: "平均CPC",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "cpm",
      label: "CPM",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "trackingPointCvTotal",
      label: "CV(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ZEUS_AD_GROUP_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvClickThrough",
      label: "ラストクリックCV(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvAssist",
      label: "アシストクリックCV(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvrTotal",
      label: "CVR(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ZEUS_AD_GROUP_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCvrClickThrough",
      label: "ラストクリックCVR(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCvrAssist",
      label: "アシストクリックCVR(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ZEUS_AD_GROUP_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCpaTotal",
      label: "CPA(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ZEUS_AD_GROUP_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "trackingPointCpaClickThrough",
      label: "ラストクリックCPA(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "trackingPointCpaAssist",
      label: "アシストクリックCPA(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ZEUS_AD_GROUP_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "lastCvTotal",
      label: "最適化ポイントCV",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "lastCvrTotal",
      label: "最適化ポイントCVR",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "lastCpaTotal",
      label: "最適化ポイントCPA",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
  ];

  const columnsMemo =  useMemo(() => applyApolloSharedColumnSettings(
    generateColumns(columns, STORAGE_KEY.ZEUS_AD_GROUP_LIST, setPoints, deletedSetPoints),
    {pageId: APOLLO_PAGE_ID.ADGROUP_ZEUS, accountGroupId: accountgroupid, data: tableData}
  ), [tableData, drawerState, columnFilterForStatus, columnFilterForDisplayParentArchive, placementSettingsOptions, setPoints, deletedSetPoints, accountgroupid]);
  const optionsMemo : DataTableOptions = useMemo(() => createTableOptions(columnsMemo), [tableData, setPoints, deletedSetPoints, columnsMemo, accountgroupid]);

  useEffect(() => {
    saveApolloSharedCalendar(startDate, endDate);
  }, [startDate, endDate]);

  // function
  const editIconClick = (index: number) => {
    setAdGroupId(tableData[index].id);
    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    })
  }

  const adGroupInfo = React.useRef<AdGroupWithPerformanceZeus>(initEditAdGroup);
  const newStatusInfo = React.useRef(-1);
  const resultApi = React.useRef(-1);
  /** ステータス更新 */
  const handleStatusChange = async(checked: boolean, row: AdGroupWithPerformanceZeus) => {
    setProgress(true);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })

    let isError = false;
    let adGroupZeus: AdGroupZeus = {
      id: 0,
      createdAt: "",
      updatedAt: "",
      lastUpdateUserId: 0,
      adAccountId: Number(platformaccountid),
      adCampaignId: 0,
      adCampaignName: "",
      deliveryType: 1,
      name: "",
      status: 2,
      cpcLimit: 1,
      cpcLimitOver: true,
      targetingType: 0,
      customSegmentId: 0,
      affinityCategoryIds: [],
      retargetingIds: [],
      osTargetings: [],
      demographicRelations: [],
      audienceRelations: [],
      segmentRelations: [],
      cpmLimit: 1,
      billingType: 1,
      pmpType: null,
      placementSettingId: null,
    }

    const getUrl = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ad_group_path}/${row.id}`
    await ApolloAxios.get(getUrl).then(response => {
      const res = response.data;
      if (response.status !== 200) {
        isError = true;
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : "広告グループ情報の取得に失敗しました",
        });
      }

      adGroupZeus = {
        ...cloneDeep(res),
      }
    }).catch(err => {
      isError = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });

    if (isError) {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
      setProgress(false);
      return;
    };

    const newStatus = checked ? 1 : 2
    let isPlacementSettingError = false;

    if(newStatus === 1 && row.campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.DSP  && !isError && row.placementSettingId) {
      const getPlacementSettingsUrl = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_placement_settings}/${row.placementSettingId}`
      await ApolloAxios.get(getPlacementSettingsUrl).then(response => {
        const data = response.data;
        if (!isSuccessApi(data.resultCode)) {
          isError = true;
          return Promise.reject({
            open: true,
            type: getResultType(data.resultCode),
            errmsg: data?.message ? data.message : "プレースメント設定情報の取得に失敗しました",
          });
        }

        const result = data.result;
        if(result.displayStatus === DISPLAYSTATUS_WHITELIST && !result.adAccountIds.includes(Number(platformaccountid))) {
          isPlacementSettingError = true
        } else if (result.displayStatus === DISPLAYSTATUS_BLACKLIST && result.adAccountIds.includes(Number(platformaccountid))) {
          isPlacementSettingError = true
        } else if (result.publicStatus === PUBLICSTATUS_PRIVATE) {
          isPlacementSettingError = true
        }

      }).catch(err => {
        isError = true;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: err.type,
            message: err.errmsg,
          }
        });
      });
    }

    if (isError) {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
      setProgress(false);
      return;
    };

    if (isPlacementSettingError) {
      setmsg({
        type: "all",
        payload: {
          ...data,
          loading: false,
          open: true,
          type: "error",
          message: "広告グループに紐づくプレースメントが使用できない状態のため、広告グループのステータスを有効にすることができません。",
        }
      })
      setProgress(false);
      return;
    };

    // 操作ログ出力(編集)
    adGroupInfo.current = row;
    newStatusInfo.current = newStatus;
    resultApi.current = 0;
    writeLog();

    const patchUrl = `${process.env.REACT_APP_API_ENDPOINT}${patch_zeus_ad_group_path}/${row.id}`
    const body: AdGroupEditReq = {
      ...cloneDeep(adGroupZeus),
      adAccountId: Number(platformaccountid),
      cpcLimit: adGroupZeus.cpcLimit ? Number(adGroupZeus.cpcLimit) : null,
      status: newStatus,
      audienceRelations: [],
      segmentRelations: [],
    }

    await ApolloAxios.patch(patchUrl, body).then(response => {
      if (response.status !== 200) {
        // 操作ログ(失敗)
        resultApi.current = 9;
        return Promise.reject({
          open: true,
          type: "error",
          errmsg: "ステータス更新に失敗しました。",
        });
      }

      if (response.data?.resultCode === -1) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: response.data.message,
          }
        });
        return;
      }

      // 操作ログ(成功)
      resultApi.current = 1;
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });

    // 操作ログ出力(結果)
    writeLog();

    if (resultApi.current === 1) {
      setIsPushStatusToggle(true)
      setUpdateListCnt(updateListCnt + 1)
    } else {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
      setProgress(false);
    }
  }

  /** 操作ログ出力 */
  const writeLog = () => {
    if (resultApi.current < 0) return;

    const campaignOption = valueToOptionNull(adGroupInfo.current.adCampaignId, optionCampaigns)

    const itemList: ItemList[] = [
      {
        key: "ステータス",
        beforeValue: valueToOption(adGroupInfo.current.status, options_state_edit).label + "",
        afterValue: valueToOption(newStatusInfo.current, options_state_edit).label + "",
      },
    ]

    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: resultApi.current === 0 ? "execute" : "result",
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken,
      accountGroupID: state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID: state.current.accountId,
      accountName: state.current.accountName,
      campaignID: adGroupInfo.current.adCampaignId + "",
      campaignName: campaignOption ? campaignOption.label : "",
      adGroupID: adGroupInfo.current.id + "",
      adGroupName: adGroupInfo.current.name + "",
      menu: "パフォーマンス広告",
      displayName: "広告グループ一覧画面",
      category: "広告グループ",
      actionType: "更新",
      targetID: adGroupInfo.current.id + "",
      targetName: adGroupInfo.current.name + "",
      itemList: itemList,
    }

    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };

  const [progress, setProgress] = useState(true);

  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80}/>
      </Backdrop>
      <ApolloBreadcrumbs2 data={breadcrumbsData}/>
      <CustomizedSnackbars/>
      <Grid container spacing={1} justify="flex-end">
        <Grid item xs={4} md={4} style={{ display: 'flex', alignItems: 'flex-end' }}>
          <ApolloDateRangePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            {...(!isAuthorization && { startMinDate: new Date("2025-10-01T00:00:00") })}
          />
        </Grid>

        <Grid item xs={4} md={4}>
          <InputLabel id="graph-display-select">
            <Typography variant="caption">
            グラフ表示対象の選択
            </Typography>
          </InputLabel>
          <div>
            <ApolloBasicSelect
              id={"graph-display-select"}
              label=""
              isMulti={true}
              options={createOptions()}
              value={selectedValues}
              control={control}
              errors={errors}
              closeMenuOnSelect={false}
              setState={(e: any) => {
                const setVals = !e || e[e.length - 1].value === ALL ? [ALL] : e.filter((target: any) =>
                  target.value !== ALL
                ).map((target: any) => target.value);
                setSelectedValues(setVals)
              }}
              selectStyle={{ maxHeight: "70px", overflowY: "scroll"}}
            />
          </div>
        </Grid>

        <Grid item xs={4} md={4}>
        </Grid>
      </Grid>
      <ApolloPerformanceMemo
        startDate={startDate}
        endDate={endDate}
        previousStartDate={previousStartDate}
        previousEndDate={previousEndDate}
        dailyPerformanceData={chartRawDataMemo}
        previousDailyPerformanceData={previousChartRawDataMemo}
        selectedValues={selectedValues}
        data={tableData}
        columns={columnsMemo}
        options={optionsMemo}
        chartPtn={LintChartColumnsPtn.Ptn3}
        storageKeyGraph1={LintChartStorageKey.ZeusAdGroupListGraph1}
        storageKeyGraph2={LintChartStorageKey.ZeusAdGroupListGraph2}
        fileName={`chart_adGroups_performance_${moment(startDate).format("YYYYMMDD")}_${moment(endDate).format("YYYYMMDD")}.csv`}
        isPreviousPeriodChecked={isPreviousPeriodChecked}
        setIsPreviousPeriodChecked={setIsPreviousPeriodChecked}
        isPreviousPeriodDisabled={isPreviousPeriodDisabled}
        isChartDataLoaded={isChartDataLoaded}
        setPoints={setpointMemo}
        title={titleMemo}
      />
      <RightDrawer>
        <AdGroupEditZeus
          platformAccountId={platformaccountid}
          adGroupId={adGroupId}
          listReloadFunc={listReloadFunc}
        />
      </RightDrawer>
    </GenericTemplate>
  )
};

const formatCsvData = (data: any[],
                      tableData: AdGroupWithPerformanceZeus[],
                      campaigns: Option[],
                      setPoints: Option[],
                      deletedSetPoints: Option[],
                      placementSettgings: Option[]): CsvData[] => {
  const dataList: CsvData[] = [];
  let mergedSetPoints = [...setPoints, ...deletedSetPoints];
  data?.map((v: { index: any, data: any[] }) => {
      if (!v.data || v.data.length === 0) return;
      const values = tableData.filter((td) => td.id === v.data[1]);
      if (!values || values.length === 0) return;
      const d = values[0];
      const osNames: string[] = [];
      const demographic: Demographic = {
        ageRange: [],
        genders: [],
        prefectures: [],
      };

      const campaignOption = valueToOptionNull(d.adCampaignId, campaigns);
      const campaignName = campaignOption ? campaignOption.label : "";

      const placementSettgingOption = valueToOptionNull(d.placementSettingId, placementSettgings);
      const placement = placementSettgingOption ? placementSettgingOption.label : "-";

      d.osTargetings?.map((os) => {
        const option = valueToOptionNull(os.osType, options_ostype_zeus_number);
        if(option) {
          osNames.push(option.label)
        }
      });

      let campaignType = d.campaignType;
      if (campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.PERFORMANCE) {
        campaignType = ZEUS_DELIVERY_TYPE_STRING.PERFORMANCE;
      } else if (campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.DSP) {
        campaignType = ZEUS_DELIVERY_TYPE_STRING.DSP;
      }

      if (d.demographicRelations && d.demographicRelations.length > 0) {
        const dg: DemographicRelation = d.demographicRelations[0];
        if (dg.ageMin) demographic.ageRange.push(dg.ageMin);
        if (dg.ageMax) demographic.ageRange.push(dg.ageMax);
        if (dg.genderCodeList) {
          const gCode = dg.genderCodeList.split(",");
          gCode.map((code) => {
            const option = valueToOptionNull(code, options_gender);
            if (option) demographic.genders.push(option.label);
          });
        }
        if (dg.prefCodeList) {
          const pCode = dg.prefCodeList.split(",");
          pCode.map((code) => {
            const option = valueToOptionNull(code, options_pref);
            if (option) demographic.prefectures.push(option.label);
          });
        }
      }

      const list: CsvData = {
        index: v.index,
        data: [
          formatApolloCsvCell(d.id),
          formatApolloCsvCell(d.name, true),
          formatApolloCsvCell(campaignName, true),
          formatApolloCsvCell(campaignType),
          formatApolloCsvCell(d.pmpType),
          formatApolloCsvCell(placement),
          formatApolloCsvCell(valueToLabel(d.status, options_state_edit)),
          formatApolloCsvCell(valueToLabel(d.billingType, options_zeus_billing_type)),
          formatApolloCsvCell(d.campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.PERFORMANCE && d.cpcLimit ? `￥${d.cpcLimit}` : "-"),
          formatApolloCsvCell(d.campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.DSP && d.cpmLimit ? `￥${d.cpmLimit}` : "-"),
          formatApolloCsvCell(osNames.join("/")),
          formatApolloCsvCell(valueToLabel(d.targetingType, options_zeus_ad_target)),
          formatApolloCsvCell(demographic.genders.join("、")),
          formatApolloCsvCell(demographic.ageRange.join("～")),
          formatApolloCsvCell(demographic.prefectures.join("、")),
          formatApolloCsvCell(`￥${d.cost}`),
          formatApolloCsvCell(d.imp),
          formatApolloCsvCell(d.click),
          formatApolloCsvCell(`${(Math.floor((Math.round(d.ctr * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`),
          formatApolloCsvCell(`￥${d.cpc}`),
          formatApolloCsvCell(`￥${d.cpm}`),
          formatApolloCsvCell(d.trackingPointCvTotal),
          formatApolloCsvCell(d.trackingPointCvClickThrough),
          ...formatApolloCsvCellArray(generateSetPointColumns(d.trackingPointCvClickThroughSetPoints, TRACKING_POINT.CV_CLICK_THROUGH, mergedSetPoints)),
          formatApolloCsvCell(d.trackingPointCvAssist),
          ...formatApolloCsvCellArray(generateSetPointColumns(d.trackingPointCvAssistSetPoints, TRACKING_POINT.CV_ASSIST, mergedSetPoints)),
          formatApolloCsvCell(`${(Math.floor((Math.round(d.trackingPointCvrTotal * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`),
          formatApolloCsvCell(`${(Math.floor((Math.round(d.trackingPointCvrClickThrough * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`),
          ...formatApolloCsvCellArray(generateSetPointColumns(d.trackingPointCvrClickThroughSetPoints, TRACKING_POINT.CVR_CLICK_THROUGH, mergedSetPoints)),
          formatApolloCsvCell(`${(Math.floor((Math.round(d.trackingPointCvrAssist * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`),
          formatApolloCsvCell(`￥${d.trackingPointCpaTotal}`),
          formatApolloCsvCell(`￥${d.trackingPointCpaClickThrough}`),
          ...formatApolloCsvCellArray(generateSetPointColumns(d.trackingPointCpaClickThroughSetPoints, TRACKING_POINT.CPA_CLICK_THROUGH, mergedSetPoints)),
          formatApolloCsvCell(`￥${d.trackingPointCpaAssist}`),
          formatApolloCsvCell(d.lastCvTotal),
          formatApolloCsvCell(`${(Math.floor((Math.round(d.lastCvrTotal * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`),
          formatApolloCsvCell(`￥${d.lastCpaTotal}`),
        ],
      };
      dataList.push(list);
    }
  );
  return dataList;
}

export default AdGroupPageZeus;
